import React, { useContext} from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import { Link } from "react-router-dom";
import TuneIcon from "@mui/icons-material/Tune";
import InfoIcon from "@mui/icons-material/Info";
import LayoutModalDialog from "../page/Modal.jsx";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import { ImageContext } from "../page/ApiContext.jsx";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import * as XLSX from "xlsx";
import { getCookie } from "../components/Cookie.jsx";
import Badge from "@mui/material/Badge";
import MailIcon from "@mui/icons-material/Mail";
import FadeLoader from "react-spinners/FadeLoader";
import toast from "react-hot-toast";

import "../index.css";

const customStyles = {
  rows: {
    style: {
      // width: "12rem",
      minHeight: "3rem", // Override the row height
      fontSize: "0.8rem", // Set font size to small (14px)
      textAlign: "center",
    },
  },
  cells: {
    style: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      fontSize: "0.8rem", // Set font size to small (14px)
      textAlign: "center", // Center-align the text in cells
      display: "flex",
      justifyContent: "center",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f1f4f9", // Set header background color to light gray
      color: "black", // Set header text color to black
      fontSize: "0.7rem", // Set font size to small (14px)
      fontWeight: "bold", // Make font bold
      textAlign: "center", // Center-align the text in header cells
      textAlign: "center", // Center-align the text in cells
      display: "flex",
      justifyContent: "center",
    },
  },
  // tableWrapper: {
  //   style: {
  //     height: "50vh", // Ensure the table wrapper takes the full height of the viewport
  //     // overflow: "hidden", // Ensure content stays within the bounds
  //   },
  // },
};

const DataTableComponent = () => {
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [clients, setClients] = useState([]);
  const [websites, setWebsites] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedWebsite, setSelectedWebsite] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [blablacarDropData,setblablacarDropData] = useState([])
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [layout, setLayout] = useState(undefined);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [modalData, setModalData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // const [countData, setCountData] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  // const [batchId, setBatchId] = useState("");
  const [batchApiData, setBatchApiData] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    pending: 0,
    completed: 0,
  });
  const [term, setTerm] = useState(undefined);
  const [requestStatus, setRequestStatus] = useState("");
  const [rowData, setRowData] = useState("");
  const { imageApiCall } = useContext(ImageContext);
  const [project, setProject] = useState("All");
  const [requestType, setRequestType] = useState("");
  const [checkLiveData, setcheckLiveData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [row, setRow] = useState();
  const [proxyData, setProxyData] = useState([]);
  const [checkLiveStatus, setCheckLiveStatus] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [csvButtonEnable, setCSVButtonEnable] = useState(false)
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const [actionLog, setActionLog] = useState([]);
  const [Proxy,setProxy] = useState(null);
  const [Day,setDay] = useState(false);
  const [reSubmit,setResubmit] = useState(false);
  const [reSubmitfilter,setResubmitfilter] = useState(false);

  const project_map={
    "All":"all",
    "Zetta":"zetta",
    "Viaje Buses":"viaje_buses",
    "Viaje Airline":"viaje_airlines"
  }

  const {
    dashboardIds,
    setDashboardIds,
    functionalityIds,
    setFunctionalityIds,
    userRoleId,
    setUserRoleId,
  } = useContext(ImageContext);

  // Function to get today's date in 'YYYY-MM-DD' format
  const getTodayDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const token = getCookie("sqa_token");
  const username = localStorage.getItem("email");

  const toggleDiv = () => {
    setShowDiv(!showDiv);
  };

  useEffect(() => {
    const sendDate = async () => {
      setLoading(true);
      const project_dict = {
        "Viaje Airlines ": "viaje_airlines",
        Zetta: "zetta",
        "Viaje Buses": "viaje_buses",
        All: "all",
      };

      try {
        const response = await fetch("/sqa/api/fetch_batch_info", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            date: selectedDate,
            project: project_dict[project],
          }),
        });


        if (response.statusText == "Unauthorized"){
              document.cookie = `sqa_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
              localStorage.clear();
              navigate("/auth/user-info");
              return
        }

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setcheckLiveData(data?.result[0] || []);

        // Update the state with documents
        setApiData(data?.result[0] || []);
        setFilteredData(data?.result[0] || []);

        // Count statuses
        const pendingCount =
          data?.result[0]?.filter((doc) => doc.status === "Pending All").length ||
          0;
        const completedCount =
          data?.result[0]?.filter((doc) => doc.status === "Completed").length ||
          0;

        // Update status counts state
        setStatusCounts({
          pending: pendingCount,
          completed: completedCount,
        });

        // Extract unique values for dropdowns
        const uniqueClients = [
          ...new Set(data?.result[0]?.map((doc) => doc.client_id) || []),
        ];
        const uniqueWebsites = [
          ...new Set(data?.result[0]?.map((doc) => doc.site_id) || []),
        ];
        const uniqueStatuses = [
          ...new Set(
            data?.result[0]?.flatMap((doc) => [doc.status, doc.previous_pending, doc.filter_status]) || []
          ),
        ].filter(Boolean); // Removes null/undefined values

        console.log("uniqueStatuses", uniqueStatuses);
        

        // Update state with unique values
        setClients(uniqueClients);
        setWebsites(uniqueWebsites);
        setStatuses(uniqueStatuses);
        setblablacarDropData(uniqueWebsites)

        setSelectedClient("");
        setSelectedWebsite("");
        setSelectedStatus("");
        
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    if (selectedDate) {
      sendDate(project);
    }
    getProxyDetail();
  }, [selectedDate]);

  useEffect(() => {
    sendDate(project_map[project])
  }, [reSubmit]);


  const handleFetch = async (rowId) => {
    if (rowId === undefined) {
      return;
    }

    const defaultType = "batch";
    const batchId = rowId;

    // Retrieve username from local storage or use a default

    if (!username) {
      console.error("Username is required");
      return;
    }

    try {
      const response = await fetch(
        `/sqa/api/batch_request_comment/?username=${username}&type=${defaultType}&identifier=${batchId}`,
        {
          method: "GET", // or 'POST' if applicable
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,

            // Add any other headers you need here
          },
        }
      );

      if (!response.ok) {
        setBatchApiData([]);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.result.length === 0) {
        setBatchApiData([]);
        return;
      }

      setBatchApiData(data?.result[0]);
      // Handle the fetched data as needed here (e.g., displaying in console, alert, etc.)
    } catch (err) {
      console.error("Error fetching notification:", err);
    }
  };

  const handleImageClick = (batchId) => {
    const id = batchId; // Replace with the actual ID you want to fetch
    imageApiCall(id);
  };

  const handleCheckLive = async () => {
    setLoading(true);
    let successCount = 0;
    let totalCount = checkLiveData.length;

    checkLiveData.map(async (document) => {
      const batchId = document.batch_id;
      const success = await checkLive(batchId);
      if (success) {
        successCount++;
      }
      if (successCount === totalCount) {
        toast.success(`All ${totalCount} batches refreshed successfully`);
        await sendDate("all");
        setLoading(false);
      }
    });
    // for (const document of checkLiveData) {
    //   const batchId = document.batch_id;
    //   const success = await checkLive(batchId);
    //   if (success) {
    //     successCount++;
    //   }
    // }

    // Show a single toast message after all operations are completed
  };

  useEffect(() => {
    if (checkLiveStatus) {
      toast.error("Failed in refreshing all batches");
    }
  }, [checkLiveStatus]);

const downloadExcel = () => {
  // console.log(">>>>>>>sclient", selectedClient);
  // console.log(">>>>>>>sweb", selectedWebsite);
  // console.log(">>>>>>>sstatus", selectedStatus);

  // // Step 1: Filter the data dynamically based on non-empty filter values
  // const filteredDocuments = filteredData.filter(doc => {
  //   return (
  //     (selectedClient ? doc.client_id == selectedClient : true) &&
  //     (selectedWebsite ? doc.site_id == selectedWebsite : true) &&
  //     (selectedStatus ? doc.status == selectedStatus : true)
  //   );
  // });

  // Step 2: Format the filtered data
  const formattedData = filteredData.map(doc => {
      // doc["end_dtm"] = doc["end_dtm"] ? doc["end_dtm"].split(" ")[1] : null;
  
      const endTime = doc["end_dtm"] ? doc["end_dtm"].split(" ")[1] : null;
  
const {
  _id,
  batch_id,
  is_done_count,
  is_fail_count,
  is_exhausted_count,
  is_picked_count,
  time_tag,
  total_requests,
  status,
  // end_dtm, // remove this so we use the safe one below
} = doc;

const parts = batch_id.split("$");
const clientName = parts[2];
const siteName = parts[3];

return {
  "Batch ID": batch_id,
  "Client Name": clientName,
  "Site Name": siteName,
  "Time Tag": time_tag,
  "Proxy Used": "Webshare",
  "Last Action": "N/A",
  "Total Requests": total_requests,
  "Failed Request": is_fail_count,
  "Exhausetd Request": is_exhausted_count,
  "Picked Request": is_picked_count,
  "Successful Requests": is_done_count,
  "Batch Status": status,
  "End Time": endTime,
};
  });

  // Step 3: Convert the modified data to an Excel file
  if (formattedData.length === 0) {
    console.log("No data matches the selected filters.");
    alert("No data matches the selected filters.");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Data");
  XLSX.writeFile(workbook, "Filtered_Batch_Data.xlsx");
};



  const resetFilters = () => {
    setSelectedClient("");
    setSelectedWebsite("");
    setSelectedStatus("");
    // setSelectedDate(() => {
      //   const today = new Date();
      //   return today.toISOString().split("T")[0];
      // });
      if (project != "All"){
        sendDate('all')
      }
      setProject("All");
      setFilteredData(apiData);
  };

  const getSearchableData = (row) => {
    return [
      row._id,
      row._id.split("$")[2],
      "-",
      row.time_tag,
      row.is_exhausted_count,
      row?.previous_day.total_requests,
      row.previous_day.is_done_count,
      row.previous_day.is_exhausted_count,
      row.previous_day.is_fail_count,
      row.previous_day.is_picked_count,
      row?.total_requests,
      row.is_done_count,
      row.is_exhausted_count,
      row.is_fail_count,
      row.is_picked_count,
      row.status,
      row.worker_id,
    ]
      .map((item) => item?.toString().toLowerCase())
      .join(" ");
  };

  const sendDate = async (keyword = null, batchId = null) => {
    try {
      // Build the request body
      const body = {
        date: selectedDate,
        // project: keyword ? keyword : "all",
      };
      // If a batchId is provided, add it to the body to filter for that batch only
      if (keyword!=null) {
        body.project = keyword ? keyword : "all";
      }
      else if(batchId) {
        body.batch_id = batchId;
      }
  
      const response = await fetch("/sqa/api/fetch_batch_info", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data = await response.json();
  
      // If a batchId is provided, update only that batch's status in the state.
      if (batchId) {
        // Update only the specific batch row
      if (data && data.result && data.result[0]) {
        const updatedBatch = data.result[0].find(
          (entry) => entry._id === batchId
        );
        if (updatedBatch) {
          setApiData((prevData) => {
            const newData = prevData.map((row) =>
              row._id === batchId ? updatedBatch : row
            );
            // Recalculate status counts using the updated data set
            const pendingCount = newData.filter(
              (doc) => doc.status === "Pending All"
            ).length;
            const completedCount = newData.filter(
              (doc) => doc.status === "Completed"
            ).length;
            setStatusCounts({
              pending: pendingCount,
              completed: completedCount,
            });
            return newData;
          });
        }
      }
      } else {
        // Otherwise, update the entire data set.
        setApiData(data?.result[0] || []);
  
        // Count statuses
        const pendingCount =
          data?.result[0].filter((doc) => doc.status === "Pending All").length || 0;
        const completedCount =
          data?.result[0].filter((doc) => doc.status === "Completed").length || 0;
  
        setStatusCounts({
          pending: pendingCount,
          completed: completedCount,
        });
        // Extract unique values for dropdowns
        const uniqueClients = [
          ...new Set(data?.result[0]?.map((doc) => doc.client_id) || []),
        ];
        const uniqueWebsites = [
          ...new Set(data?.result[0]?.map((doc) => doc.site_id) || []),
        ];
        // const uniqueStatuses = [
        //   ...new Set(data?.result[0]?.map((doc) => doc.status) || []),
        // ];
        const uniqueStatuses = [
          ...new Set(
            data?.result[0]?.flatMap((doc) => [doc.status, doc.previous_pending, doc.filter_status]) || []
          ),
        ].filter(Boolean); // Removes null/undefined values
  
        setClients(uniqueClients);
        setWebsites(uniqueWebsites);
        setblablacarDropData(uniqueWebsites);
        setResubmitfilter(!reSubmitfilter);
        setStatuses(uniqueStatuses);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };  

  const idList = [];

  // Check if data is an array or an object with an array property
  if (Array.isArray(apiData)) {
    // Iterate through each item in the array
    apiData.forEach((item) => {
      if (item._id) {
        idList.push(item._id);
      }
    });
  } else if (apiData && apiData.items && Array.isArray(apiData.items)) {
    // If the data is an object containing an array property
    apiData.items.forEach((item) => {
      if (item._id) {
        idList.push(item._id);
      }
    });
  }

  const checkLive = async (id) => {
    try {
      const response = await fetch(
        `/sqa/api/check_live_batch/?batch_id=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data?.error_list.length != 0) {
        setCheckLiveStatus(true);
      }

      return true; // Return true if successful
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      return false; // Return false if there was an error
    }
  };

  const checkSingleLive = async (id) => {
    try {
      const response = await fetch(
        `/sqa/api/check_live_batch/?batch_id=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        toast.error("Something went wrong");
        throw new Error("Network response was not ok");
      }

      await response.json();
      await sendDate(null,id);

      toast.success(`BatchId: ${id} refreshed successfully`);
    } catch (error) {
      return false; // Return false if there was an error
    }
  };

  const handleRerunClick = async (batchId) => {
    // Disable the button immediately when clicked

    const isConfirmed = window.confirm("Are you sure you want to rerun?");
    if (!isConfirmed) return; // Stop execution if the user cancels
    try {
      const response = await fetch("/sqa/api/rerun_batch/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ batch_id: batchId }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data?.success && data.allowed) {
        toast.success("Batch rerun successfully");
      } else if (!data?.allowed) {
        toast.error(data.message);
      } else {
        toast.error("Please try again");
      }

      console.log("Success:", data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getProxyDetail = async () => {
    try {
      const response = await fetch("/sqa/api/get_proxy_details/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setProxyData(data?.result);
    } catch (error) {
      return false; // Return false if there was an error
    }
  };

  const filterData = () => {
    let filtered = apiData;

    if (selectedDate) {
      filtered = filtered.filter((item) => item.scrape_date == selectedDate);
    }
    if (selectedClient) {
      filtered = filtered.filter((item) => {
        return item.client_id == selectedClient;
      });
    }
    if (selectedWebsite) {
      filtered = filtered.filter((item) => item.site_id == selectedWebsite);
    }
    if (selectedStatus) {
      if (["Pending All", "Completed"].includes(selectedStatus)) {
      filtered = filtered.filter((item) => item.status == selectedStatus);
      } else if (selectedStatus == "Pending") {
        filtered = filtered.filter((item) => item.previous_pending == selectedStatus);
      }
      else{
        filtered = filtered.filter((item) => {
          return item.filter_status == selectedStatus;
        });
      }
    }

    // Apply search filter
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        getSearchableData(item).includes(lowercasedSearchTerm)
      );
    }
    
    setFilteredData(filtered);
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedFilterData = debounce(filterData, 300);

  useEffect(() => {
    debouncedFilterData();
  }, [selectedDate, searchTerm, apiData]);

  
  // useEffect(() => {
  //   // console.log("this is what is called on selecting client")
  //   // console.log(">>>>>",blablacarDropData);

  //   if (blablacarDropData.length != 0 && selectedClient == "BlaBlaCar"){
  //     const excludeKeywords = ["Hotel", "Pms", "Flight", "Train", 'redbus'];
  //     const bbcFilterData = blablacarDropData.filter(item => 
  //         !excludeKeywords.some(keyword => item.includes(keyword))
  //     );
  
  //     setWebsites(bbcFilterData)
  //   }
  //   else{
  //     setWebsites(blablacarDropData)
  //   }

      
  // }, [selectedClient]);


  useEffect(() => {
    const excludeKeywords = ["Hotel", "Pms", "Flight", "Train", "redbus", "Event"];
    if (blablacarDropData.length !== 0 && selectedClient === "BlaBlaCar") {
      const bbcFilterData = blablacarDropData.filter(item =>
        !excludeKeywords.some(keyword => item.includes(keyword))
      );
      
      setWebsites(bbcFilterData)
    }
    else if (blablacarDropData.length !== 0 && selectedClient === "internal") {
      const internalFilterData = blablacarDropData.filter(item =>
        excludeKeywords.some(keyword => item.includes(keyword))
      );      
      setWebsites(internalFilterData);
    }
    else {
      setWebsites(blablacarDropData)
    }


  }, [selectedClient, reSubmitfilter]);

  const sendPostRequest = async (
    id,
    type,
    totalCount,
    status,
    pageSize = 1000
  ) => {
    setCompleted(false);
    const numPages = Math.ceil(totalCount / pageSize);
    let combinedResult = [];

    for (let page = 1; page <= numPages; page++) {
      const start = (page - 1) * pageSize;
      const end = Math.min(start + pageSize, totalCount);

      try {
        const response = await fetch("/sqa/api/request_level_data/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id, type, start, end }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (page == numPages) {
          setCompleted(true);
        }
        combinedResult = combinedResult.concat(data?.result[0]?.documents); // Collect results
        setModalData(combinedResult); // Store result in modalData state
        if (page == 1) {
          setRequestStatus(status);
          setSelectedRowId(id);
          setLayout("fullscreen"); // Set layout to fullscreen
          setTerm("request");
        }
      } catch (error) {
        console.error(`Error for page ${page}:`, error);
      }
    }

    return combinedResult; // Return combined results
  };

  const handleLinkClick = async (row, rowId, type, totalCount, status) => {
    await sendPostRequest(rowId, type, totalCount, status);
    setRowData(row);
  };

  const insertBreaks = (str, interval = 5) => {
    return str.replace(new RegExp(`(.{${interval}})`, "g"), "$1&#8203;");
  };

  const getProxyByBatchId = (batchId) => {
    let formattedString = batchId.split("$").slice(2).join("$");

    if (batchId.toLowerCase().includes("redbus")) {
      let csf_parts = formattedString.split("$");
      if (csf_parts[0].toLowerCase().startsWith("adhoc")) {
        csf_parts[0] = "internal";
      }
      formattedString = csf_parts.join("$");
    }
    
    const matchedData = proxyData?.find((data) => data._id === formattedString);

    return matchedData ? matchedData.proxy : "";
  };


// Function to fetch action logs
  const fetchActionLog = async (batchID) => {
    if (!batchID) return; // Prevent API call if batchID is null

    try {
      const response = await fetch("/sqa/api/fetch_action_log", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ batch_id: batchID }),
      });

      const data = await response.json();

      if (response.ok) {
        setActionLog(data.result); // Set action log list in state
      } else {
        setActionLog([]); // Set empty array if no logs found
      }
    } catch (error) {
      console.error("Error fetching action logs:", error);
      setActionLog([]); // Reset state on error
    }
  };

  const columns = [
    {
      name: (
        <div className="whitespace-normal break-words text-center">
          Batch ID
        </div>
      ),
      width: "18.5rem",
      selector: (row) => row.batch_id,
      sortable: true,
      sortIcon: ({ sortDirection }) =>
        sortDirection === "asc" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />,
      cell: (row) => (
        // <div className="text-left ">{row?.batch_id}</div>
        // <div
        //   className="whitespace-normal break-words text-left left-align"
        //   dangerouslySetInnerHTML={{ __html: insertBreaks(row.batch_id) }}
        // />
        <Link
        className="text-blue-500 pl-1"
        onClick={() =>(
          setLayout("fullscreen"),// only have to pass
          setTerm("action_log"),
          fetchActionLog(row?.batch_id),
          setModalData(row),
          setProxy(getProxyByBatchId(row.batch_id))
      )}
      >
        {row._id}
      </Link>
      ),
    },
    {
      name: <div className="pr-1"> Client</div>,
      width: "full",
      selector: (row) => {
        const parts = row._id.split("$");
        return parts[2];
      },
      sortable: true,
      cell: (row) => {
        const parts = row._id.split("$");
        const clientName = parts[2];
        // Capitalize the first letter of the clientName
        const capitalizedClientName =
          clientName.charAt(0).toUpperCase() + clientName.slice(1);

        return (
          <div className="whitespace-norma break-words pr-4 min-w-[2px]">
            {capitalizedClientName}
          </div>
        );
      },
    },

    {
      name: <div className="text-center pl-3">Proxy Used</div>,
      width: "full",
      selector: (row) => getProxyByBatchId(row.batch_id),
      sortable: false,
      cell: (row) => (
        <div className="whitespace-normal break-words text-center min-w-[130px]">
          {getProxyByBatchId(row.batch_id)}
        </div>
      ),
    },
    {
      name: <div className="text-center pl-4">Time Tag </div>,
      width: "full",
      selector: (row) => row?.time_tag,
      sortable: true,
      cell: (row) => (
        <div className="whitespace-normal break-words text-center ">
          {row?.time_tag}
        </div>
      ),
    },
    {
      name: <div className="text-center pl-4">End Time</div>,
      width: "full",
      selector: (row) => row?.end_dtm?.split(" ")[1],
      sortable: true,
      cell: (row) => (
        <div className="whitespace-normal break-words">
          {row?.end_dtm?.split(" ")[1] || "-"}
        </div>
      ),
    },
    {
      name: <div className="pl-2">Previous Day Request</div>,
      width: "10rem",
      selector: (row) => row.previous_day.total_requests,
      sortable: true,
      cell: (row) => {
        let total = row?.previous_day.total_requests || 1;
        const completed = row?.previous_day.is_done_count || 0;
        const failed = row?.previous_day.is_fail_count || 0;
        const exhausted = row?.previous_day.is_exhausted_count || 0;
        const picked = row?.previous_day.is_picked_count || 0;

        let completedPercentage = 0;      
        try{
          completedPercentage = Math.floor(((completed + failed + exhausted) / total) * 100);
          if (isNaN(completedPercentage)) throw new Error("Invalid value: Value must be a number"); 
        }
        catch{
          total=1;
          completedPercentage = Math.floor(((completed + failed + exhausted) / total) * 100);
        }

        const failurePercentage = Math.floor((failed / total) * 100);
        const successPercentage = Math.floor((completed / total) * 100);
        const exhaustedPerentage = Math.floor((exhausted / total) * 100);
        const isPickedPercentage = Math.floor((picked / total) * 100);
        
        const remainingRequests = (row?.previous_day.total_requests||0) - (completed + failed + exhausted);
        return (
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  minWidth: 320,
                  whiteSpace: "pre-wrap",
                  textAlign: "center",
                },
              },
            }}
            title={`Completion: ${completedPercentage}% | Remaining Request: ${remainingRequests} | Failure: ${failurePercentage}%`}
            arrow
          >
            <div className="whitespace-pre-wrap break-words text-center min-w-[160px]">
              <div className="mb-1">
                {row?.previous_day.total_requests || 0}
              </div>
              <div>
                <Link
                  className="text-green-500"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row.previous_day.batch_id,
                      "is_done_count",
                      completed,
                      setRequestType("Completed Request"),
                      setRow(row?._id),
                      setDay(false)
                    )
                  }
                >
                  {completed}
                </Link>{" "}
                |
                <Link
                  className="text-red-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row.previous_day.batch_id,
                      "is_fail_count",
                      failed,
                      setRequestType("Failed Request"),
                      setRow(row?._id),
                      setDay(false)
                    )
                  }
                >
                  {failed}
                </Link>{" "}
                |
                <Link
                  className="text-yellow-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row.previous_day.batch_id,
                      "is_exhausted_count",
                      exhausted,
                      setRequestType("Exhausted Request"),
                      setRow(row?._id),
                      setDay(false)
                    )
                  }
                >
                  {exhausted}
                </Link>{" "}
                |
                <Link
                  className="text-blue-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row.previous_day.batch_id,
                      "is_picked_count",
                      picked,
                      setRequestType("Picked Request"),
                      setRow(row?._id)
                    )
                  }
                >
                  {picked}
                </Link>
              </div>
            </div>
          </Tooltip>
        );
      },
    },      
    {
      name: <div className="pl-2">Selected Date Request</div>,
      width: "10rem",
      selector: (row) => row?.total_requests,
      sortable: true,
      cell: (row) => {
        const total = row?.total_requests || 1; // Avoid division by zero
        const completed = row?.is_done_count || 0;
        const failed = row?.is_fail_count || 0;
        const exhausted = row?.is_exhausted_count || 0;
        const picked = row?.is_picked_count || 0;
      
        const completedPercentage = Math.floor(((completed + failed + exhausted) / total) * 100);
        const remainingRequests = (row?.total_requests||0) - (completed + failed + exhausted);
        const failurePercentage = Math.floor((failed / total) * 100);
        const successPercentage = Math.floor((completed / total) * 100);
        const exhaustedPerentage = Math.floor((exhausted / total) * 100);
        const isPickedPercentage = Math.floor((picked / total) * 100);
      
        return (
          <Tooltip
            title={`Completion: ${completedPercentage}% | Remaining Request: ${remainingRequests} | Failure: ${failurePercentage}%`}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  minWidth: 320,
                  whiteSpace: "pre-wrap",
                  textAlign: "center",
                },
              },
            }}
          >
            <div className="whitespace-pre-wrap break-words text-center min-w-[160px]">
              <div className="mb-1">{row?.total_requests || 0}</div>
              <div>
                <Link
                  className="text-green-500"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row?._id,
                      "is_done_count",
                      completed,
                      "Done",
                      setRequestType("Completed Request"),
                      setRow(row?._id),
                      setDay(true)
                    )
                  }
                >
                  {completed}
                </Link>{" "}
                |
                <Link
                  className="text-red-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row?._id,
                      "is_fail_count",
                      failed,
                      "Failed",
                      setRequestType("Failed Request"),
                      setRow(row?._id),
                      setDay(true)
                    )
                  }
                >
                  {failed}
                </Link>{" "}
                |
                <Link
                  className="text-yellow-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row?._id,
                      "is_exhausted_count",
                      exhausted,
                      "Exhausted",
                      setRequestType("Exhausted Request"),
                      setRow(row?._id),
                      setDay(true)
                    )
                  }
                >
                  {exhausted}
                </Link>{" "}
                |
                <Link
                  className="text-blue-500 pl-1"
                  onClick={() =>
                    handleLinkClick(
                      row,
                      row?._id,
                      "is_picked_count",
                      picked,
                      "Picked",
                      setRequestType("Picked Request"),
                      setRow(row?._id),
                      setDay(true)
                    )
                  }
                >
                  {picked}
                </Link>
              </div>
            </div>
          </Tooltip>
        );
      },
    },      
    {
      name: <div>Batch Status</div>,
      width: "7rem",
      selector: (row) => row.status ,
      sortable: true,
      cell: (row) => (
        <div
          className={` rounded-md text-xs   py-2  mr-2  ${
            row.status === "Completed"
              ? "bg-[#ccf0eb] text-teal-500 text-xs w-[4.5rem]"
            : row.status === "Pending All"
              ? "bg-[#D8D9F9] text-blue-500 text-xs w-[4.5rem]"
              : "bg-gray-200 text-black text-xs"
          }`}
        >
          {row.status?.split(" ")[0]}
        </div>
      ),
    },
    {
      name: <div>View</div>,
      width: "5rem",

      selector: (row) => row.worker_id,
      sortable: false,
      cell: (row) => (
        <div
          onClick={() => {
            setTerm("image");
            setLayout("fullscreen");
            setModalData(row);
            handleImageClick(row.batch_id);
          }}
          className="border-2 rounded-md p-1 cursor-pointer whitespace-normal break-words border-blue-500 text-blue-500  hover:text-white hover:bg-[#4880FF] "
        >
          <ImageSearchIcon fontSize="small" />
        </div>
      ),
    },
  ];

  if (functionalityIds.includes(202)) {
    columns.push({
      name: <div className="pr-2">Refresh</div>,
      width: "8rem",
      selector: (row) => row.worker_id,
      sortable: false,
      cell: (row) => (
        <div
          // onClick={() => checkSingleLive(row._id)}
          onClick={() => checkSingleLive(row._id)
            // && row.status !== "Completed" 
          }
          className={`rounded-md border-2 p-1 border-[#FFCA28] ${
            // row.status === "Completed"
              // ? "cursor-not-allowed text-yellow-500" :
               "cursor-pointer text-yellow-500"
          } whitespace-normal break-words mr-2 hover:text-white hover:bg-[#FFCA28]`}
        >
          Refresh
        </div>
      ),
    });
  }

  if (functionalityIds.includes(203)) {
    columns.push({
      name: <div className="pr-2">Rerun</div>,
      width: "6rem",
      selector: (row) => row.batch_id,
      sortable: false,
      cell: (row) => {
        

        return (
          <div
            onClick={() => handleRerunClick(row.batch_id)}
            // title={isDisabled ? "Rerun functionality is not available" : ""}
            className={`rounded-md border-2 p-1 border-blue-500 text-blue-500 whitespace-normal break-words mr-2 cursor-pointer hover:text-white hover:bg-blue-500`}
          >
            Rerun
          </div>
        );
      },
    });
  }

  if (functionalityIds.includes(206)) {
    columns.push({
      name: <div className="pr-3">Action</div>,
      width: "8rem",
      selector: (row) => row.time_tag,
      sortable: false,
      cell: (row) => (
        <div className="flex flex-col gap-2 items-center pr-3">
          <div
            onClick={async () => {
              setTerm("batch_notification");
              setModalData(row);
              await handleFetch(row?._id);
              setLayout("fullscreen");
              setProxy(getProxyByBatchId(row.batch_id))
            }}
            className="border-2 border-[#4880FF] w-[3rem] py-1 text-[#4880FF] rounded-md cursor-pointer hover:bg-[#4880FF] hover:text-white text-xs"
          >
            Notify
          </div>
        </div>
      ),
    });
  }

  async function action_log(batchId) {
    try {
      const data = {
        batchId: batchId,
        username: username,
        action: "batch",
        type: "batch_notification",
        time: new Date().toISOString(),
      };

      const response = await fetch("/sqa/api/action_log/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const jsonResponse = await response.json();
      return jsonResponse;
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      // throw error;
    }
  }

  return (
    <>
      {loading ? (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
          <FadeLoader
            color="#88adff"
            loading={loading}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
            speedMultiplier
          />
        </div>
      ) : (
        <div className="w-[100%] h-[100vh] pt-12">
          <div className="">
            {" "}
            {/* Parent div with spacing between children */}
            <div className=" pt-4 px-4 flex w-full">
              {" "}
              {/* First child */}
              <div className="flex items-center justify-between w-full ">
                <div className="flex space-x-4 relative">
                  {" "}
                  {/* Row for left side cards */}
                  <div
                    onClick={toggleDiv}
                    className="text-black flex items-center justify-center cursor-pointer border border-black rounded-full px-4"
                  >
                    <TuneIcon />
                    <Tooltip title="Select Domain" placement="right-start">
                      <button className="text-xs py-2 px-3">{project}</button>
                    </Tooltip>
                  </div>
                  {showDiv && (
                    <div className="absolute top-12 left-0 mt-2 mr-4 w-96 h-auto max-h-[400px] p-4 bg-white shadow-lg rounded-lg overflow-auto z-50">
                      <div className="flex justify-between p-3">
                        <h1 className="font-bold">Select Domain</h1>
                        <div onClick={toggleDiv} className="cursor-pointer">
                          <CloseIcon />
                        </div>
                      </div>
                      <div className="border-b-2 border-black"></div>
                      <div className="grid grid-cols-2 gap-6 text-center py-2">
                        <div
                          className="border rounded-xl px-4 py-2 transition-colors duration-300 hover:bg-blue-500 hover:text-white cursor-pointer"
                          onClick={() => {
                            setProject("All");
                            sendDate("all");
                            setShowDiv(!showDiv);
                            setSelectedClient("");
                            setSelectedWebsite("");
                            setSelectedStatus("");
                          }}
                        >
                          All
                        </div>
                        <div
                          className="border rounded-xl px-4 py-2 transition-colors duration-300 hover:bg-blue-500 hover:text-white cursor-pointer"
                          onClick={() => {
                            setProject("Zetta");
                            sendDate("zetta");
                            setShowDiv(!showDiv);
                            setSelectedClient("");
                            setSelectedWebsite("");
                            setSelectedStatus("");
                          }}
                        >
                          Zetta
                        </div>
                        <div
                          className="border rounded-xl px-4 py-2 transition-colors duration-300 hover:bg-blue-500 hover:text-white cursor-pointer"
                          onClick={() => {
                            setProject("Viaje Airlines");
                            sendDate("viaje_airlines");
                            setShowDiv(!showDiv);
                            setSelectedClient("");
                            setSelectedWebsite("");
                            setSelectedStatus("");
                          }}
                        >
                          Viaje Airlines
                        </div>
                        <div
                          className="border rounded-xl px-4 py-2 transition-colors duration-300 hover:bg-blue-500 hover:text-white cursor-pointer"
                          onClick={() => {
                            setProject("Viaje Buses");
                            sendDate("viaje_buses");
                            setShowDiv(!showDiv);
                            setSelectedClient("");
                            setSelectedWebsite("");
                            setSelectedStatus("");
                          }}
                        >
                          Viaje Buses
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col space-y-4">
                <div className="flex space-x-4 justify-end">
                  {" "}
                  {/* Row for right side cards */}
                  <div
                    className="relative text-blue-400 flex items-center justify-center cursor-pointer"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <InfoIcon />
                    {isHovered && (
                      <div className="absolute left-[-14rem] top-0 mb-2 w-70 p-4 bg-white border rounded shadow-lg text-sm text-gray-700">
                        <div className="flex flex-col gap-2">
                          <div className="flex gap-2 text-green-500">
                            <CircleIcon />
                            <p className="text-black">
                              Completed Batch/Request
                            </p>
                          </div>
                          <div className="flex gap-2 text-yellow-500">
                            <CircleIcon />
                            <p className="text-black">
                              Exhausted Batch/Request
                            </p>
                          </div>
                          <div className="flex gap-2 text-red-500">
                            <CircleIcon />
                            <p className="text-black">Failed Batch/Request</p>
                          </div>
                          <div className="flex gap-2 text-blue-500">
                            <CircleIcon />
                            <p className="text-black">Pending Batch/Request</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      setLayout("center");
                      setTerm("bell-icon");
                      // setNotificationCount(0);
                    }}
                    className="text-yellow-600 flex items-center justify-end cursor-pointer py-2"
                  >
                    <Badge badgeContent={notificationCount} color="primary">
                      <NotificationsIcon color="#F2B10A" />
                    </Badge>
                  </div>
                </div>
                <div className="">
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded-full text-xs"
                    id="searchFilter"
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="px-4 flex flex-col text-xs">
              {/* Date Selector and Dropdowns */}
              <div className="flex flex-row mb-4 justify-between">
                <div className="flex items-center">
                  <div className="flex flex-col space-y-1-md space-l-2">
                    <label
                      htmlFor="date"
                      className="block text-gray-700 font-semibold "
                    >
                      Date:
                    </label>
                    <input
                      id="date"
                      type="date"
                      className="border border-gray-300 p-2 mt-1 rounded"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      max={getTodayDate()}
                    />
                  </div>
                  <div className="flex flex-col space-y-1 space-x-4 w-32 ">
                    <label
                      htmlFor="client"
                      className="block text-gray-700 font-semibold pl-4"
                    >
                      Client:
                    </label>
                    <select
                      id="client"
                      className="border border-gray-300 p-2 mt-1 rounded "
                      value={selectedClient}
                      onChange={(e) => setSelectedClient(e.target.value)}
                    >
                      <option value="">All</option>
                      {clients.map((client, index) => (
                        <option key={index} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex flex-col space-y-1 space-x-4 w-32 ">
                    <label
                      htmlFor="website"
                      className="block text-gray-700 font-semibold pl-4"
                    >
                      Website:
                    </label>
                    <select
                      id="website"
                      className="border border-gray-300 p-2 rounded"
                      value={selectedWebsite}
                      onChange={(e) => setSelectedWebsite(e.target.value)}
                    >
                      <option value="">All</option>
                      {websites.map((website, index) => (
                        <option key={index} value={website}>
                          {website}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex flex-col space-y-1 space-x-4 w-32 ">
                    <label
                      htmlFor="status"
                      className="block text-gray-700 font-semibold pl-4"
                    >
                      Status:
                    </label>
                    <select
                      id="status"
                      className="border border-gray-300 p-2 rounded"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      {statuses.map((status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="pt-5 pl-4 pr-2">
                    <button
                      onClick={() => {
                        setResubmit(!reSubmit);
                        filterData();}}
                      className="border border-gray-300 py-2 bg-[#4880FF] px-4 rounded text-white hover:bg-blue-600"
                    >
                      Submit
                    </button>
                  </div>
                  {functionalityIds.includes(204) && (
                    <div className="pt-5 pr-2">
                      <div
                        onClick={() => {resetFilters() ; setCSVButtonEnable(false)}}
                        className="text-[#EA0234] cursor-pointer border-b border-red-500 hover:text-white hover:bg-red-500 rounded-md border border-red-500 p-1 "
                      >
                        <RotateLeftIcon /> Reset Filter
                      </div>
                    </div>
                  )}
                  {
                  }
                  <div className="pt-5">

                    <div
                      onClick={downloadExcel}
                      className="text-[#00B68A] border-2 border-[#00B68A] rounded p-1  cursor-pointer hover:bg-[#00B68A] hover:text-white"
                    >
                      <InsertDriveFileIcon fontSize="small" /> CSV
                    </div>
                  </div>
                  {/* <div className="pt-5 pl-3 pr-2">
                    <button
                      onClick={() => {
                        sendDate(project_map[project])}}
                      className="border border-gray-600 py-2 px-4 rounded text-Black hover:bg-gray-200"
                    >
                      Reload
                    </button>
                  </div> */}
                </div>
                {functionalityIds.includes(202) && (
                  <div className="flex items-center text-xs pt-4">
                    <div className="flex flex-col gap-1  ">
                      <div
                        onClick={handleCheckLive}
                        className="text-yellow-500 border-2 rounded-md p-1 border-[#FFCA28] hover:text-white hover:bg-[#FFCA28] cursor-pointer "
                      >
                        Refresh All
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="px-4 justify-between flex ">
              {" "}
              {/* Third child */}
              <div className="flex space-x-4">
                {" "}
                {/* Flex container for cards */}
                <div className="w-20 h-20 border-2 rounded-lg border-green-500 flex flex-col text-center justify-center text-green-500 font-bold">
                  {" "}
                  {/* Green card */}
                  <span className="text-xs ">Completed Batch</span>
                  <span className="text-xs">{statusCounts?.completed}</span>
                </div>
                <div className="w-20 h-20 border-2 rounded-lg border-blue-500 flex flex-col text-center justify-center text-blue-500 font-bold">
                  {" "}
                  {/* Blue card */}
                  <span className="text-xs">Pending Batch</span>
                  <span className="text-xs">{statusCounts?.pending}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="pl-5 pt-3 rounded-md ">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              customStyles={customStyles}
              noDataComponent={<div className="py-10">No Records Found</div>}
              persistTableHead
              fixedHeader="true"
              fixedHeaderScrollHeight="80vh"
            />

            <LayoutModalDialog
              requestType={requestType}
              dataData={rowData}
              batchData={batchApiData}
              term={term}
              status={requestStatus}
              setLayout={setLayout}
              layout={layout}
              selectedRowId={selectedRowId}
              modalData={modalData}
              setNotificationCount={setNotificationCount}
              batchId={row}
              requestState={completed}
              action_log_data={actionLog}
              proxy_data={Proxy}
              day={Day}
              checkSingleLive={checkSingleLive}
              functionalityIds={functionalityIds}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DataTableComponent;
